import type { ChatReplySnapshotDto, ChatMessageDto } from "../../api/shellApi";

type Props = {
  snapshot: ChatReplySnapshotDto | ChatMessageDto | null;
  onCancel?: () => void;
  compact?: boolean;
};

function previewOf(snapshot: ChatReplySnapshotDto | ChatMessageDto): {
  name: string;
  text: string;
} {
  if ("contentPreview" in snapshot) {
    return {
      name: snapshot.senderName || "משתמש",
      text: snapshot.isDeleted
        ? "הודעה זו נמחקה"
        : snapshot.contentPreview || "הודעה",
    };
  }
  return {
    name: "הודעה",
    text: snapshot.content || "הודעה",
  };
}

export function ChatReplyPreview({ snapshot, onCancel, compact }: Props) {
  if (!snapshot) return null;
  const { name, text } = previewOf(snapshot);
  return (
    <div className={`chat-reply-preview${compact ? " chat-reply-preview--compact" : ""}`}>
      <div className="chat-reply-preview__bar" aria-hidden />
      <div className="chat-reply-preview__body">
        <strong>{name}</strong>
        <span>{text}</span>
      </div>
      {onCancel ? (
        <button
          type="button"
          className="chat-reply-preview__cancel"
          onClick={onCancel}
          aria-label="ביטול תגובה"
        >
          ×
        </button>
      ) : null}
    </div>
  );
}
